import { useStore } from '@nanostores/react'
import { CONSTS } from 'config/objectConst'
import { atom } from 'nanostores'
import { useRef } from 'react'
import {
	ActionsStore,
	useAnchorClass,
	useLegacyPosition,
	useManageOpen
} from 'shared/position'

import css from './InformationalTip.module.css'
// import arrow from 'assets/image/icons/svg/arrow-left.svg'

type TipKey = keyof typeof CONSTS.TIPS

const $tipKey = atom<'' | TipKey>('')

const actionStore = new ActionsStore({
	getValue: element => element?.dataset.id ?? ''
})

InformationalTip.open = (key: TipKey, trigger: HTMLElement) => {
	$tipKey.set(key)
	actionStore.toggleTrigger(trigger)
}

InformationalTip.useAnchorClass = (id: string) =>
	useAnchorClass({
		anchorClassName: css.anchored,
		id,
		store: actionStore
	})

export function InformationalTip() {
	const key = useStore($tipKey)
	const info = key ? CONSTS.TIPS[key] : null

	const ref = useRef<HTMLDivElement | null>(null)
	useManageOpen(ref, actionStore)
	useLegacyPosition(ref, actionStore)

	return (
		<div
			className={css.root}
			// @ts-ignore Recheck in React 19
			popover='auto'
			ref={ref}
		>
			<h2 className={css.title}>{info?.title ?? ''}</h2>

			<div>
				{info?.content.map(item => (
					<p
						dangerouslySetInnerHTML={{ __html: item }}
						key={item}
						// style={{ whiteSpace: maxWidth ? "wrap" : "nowrap" }}
					/>
				))}

				{/* {data.more && (
				<a
					href={data.more}
					className="link"
					target="_blank"
					rel="noopener noreferrer"
					onClick={() => onClose(false)}
				>
					More
					<img src={arrow} alt="arrow" />
				</a>
			)} */}
			</div>
		</div>
	)
}
